import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ENVIRONMENT, Environment } from '@environment';
import { isLocalhost } from '@usheru-hff/sdk/utils';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  $mapsLoaded = new BehaviorSubject<boolean>(false);

  disabledMaps = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(ENVIRONMENT) private env: Environment,
    private translateService: TranslationsService
  ) {}

  public loadGoogleMapsScripts(): void {
    if (this.disabledMaps || isLocalhost(this.document)) {
      return;
    }

    // the app releads when the language is selected
    // https://developers.google.com/maps/faq#languagesupport
    const language = this.translateService.currentLanguage();

    const mapsScript = this.document.createElement('script');
    mapsScript.setAttribute('async', '');
    mapsScript.src = `https://maps.googleapis.com/maps/api/js?libraries=places&v=weekly&key=${
      this.env.google.maps_key
    }&loading=async&callback=__googleMapsLoaded&language=${language.code}`;
    this.document.head.appendChild(mapsScript);
    window['__googleMapsLoaded'] = () => {
      this.$mapsLoaded.next(true);
    };
  }

  generateMarker(args: { latitude: number; longitude: number; title?: string }): google.maps.Marker | null {
    if (!this.$mapsLoaded.value) return null;
    const { latitude: lat, longitude: lng, title } = args;
    return new google.maps.Marker({ position: { lat, lng }, title });
  }
}
